module.exports = __webpack_public_path__ + "static/media/blogpost1.b43ce8f2.png";